module.exports = __webpack_public_path__ + "img/avatar3.47402fba.png";